"use client"

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { realTimeDb, auth, httpsCallable, functions } from '../firebase';
import { ref, onValue, off } from 'firebase/database';

const DashboardHistory2 = () => {
    const [data, setData] = useState([]);
    const [openDropdown, setOpenDropdown] = useState('');
    const [filter, setFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');

    useEffect(() => {
        const user = auth.currentUser;
        const dbRef = ref(realTimeDb, `customers/${user.uid}/delHistory`);

        const handleValue = onValue(dbRef, (snapshot) => {
            const fetchedData = [];
            snapshot.forEach((childSnapshot) => {
                const item = childSnapshot.val();
                item.id = childSnapshot.key;
                fetchedData.push(item);
            });
            setData(fetchedData);
        }, (error) => {
            console.error("Error reading data: ", error);
        });

        return () => {
            off(dbRef, handleValue);
        };
    }, []);

    const filteredData = data.filter(item => 
        (item.carID?.toLowerCase().includes(filter.toLowerCase()) ||
        item.clientID?.toLowerCase().includes(filter.toLowerCase()) ||
        item.description?.toLowerCase().includes(filter.toLowerCase()) ||
        item.name?.toLowerCase().includes(filter.toLowerCase())) &&
        (!typeFilter || item.type === typeFilter)
    );

    const handleUndo = async (id, data) => {    
        const undoData = {
            Id: id,
            Data: data,
        }
        console.log(undoData);
        console.log('Undoing operation...');
        try {
            const undo = httpsCallable(functions, 'undo');
            const result = await undo({ id: undoData.Id, data: undoData.Data });
            console.log(result.data);
            console.log(`Undo operation has been performed.`);
        } catch (error) {
            console.error('Error performing undo: ', error);
        }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.1
          }
        }
      };
    
      const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
            stiffness: 100
          }
        }
      };

    return (
        <motion.div
            id="main-content"
            className="relative w-full h-full overflow-y-auto bg-gray-50 lg:ml-56 dark:bg-gray-900"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <main>
                <section className="flex-grow bg-gray-50 dark:bg-gray-900 p-4">
                    <motion.div className="bg-white relative shadow-md rounded-lg overflow-hidden border border-gray-200 dark:bg-gray-800 dark:border-gray-700" variants={itemVariants}>
                        <div className="flex flex-row md:flex-row items-center justify-between p-4">
                            <div className="flex-grow w-full md:w-1/2">
                                <form id="searchForm" className="flex items-center">
                                    <label htmlFor="simple-search" className="sr-only">Căutare</label>
                                    <div className="relative w-fit">
                                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                            <svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-400"
                                                fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd"
                                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                                    clipRule="evenodd" />
                                            </svg>
                                        </div>
                                        <input
                                            type="text"
                                            id="simple-search"
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                            placeholder="Căutare în istoric"
                                            required=""
                                            onChange={(e) => setFilter(e.target.value)}
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className="w-1/4 md:w-auto flex flex-col justify-end flex-shrink-0">
                                <div className="flex w-full md:w-auto gap-2 md:flex-col hidden">
                                    <motion.button
                                        id="actionsDropdownButton"
                                        className="w-full md:w-auto flex items-center justify-center py-2 px-4 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                                        type="button"
                                        onClick={() => setOpenDropdown(openDropdown === 'actions' ? '' : 'actions')}
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        <svg className="-ml-1 mr-1.5 w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path clipRule="evenodd" fillRule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                                        </svg>
                                        Acțiuni
                                    </motion.button>
                                    <motion.button
                                        id="sortDropdownButton"
                                        className="w-full md:w-auto flex items-center justify-center py-2 px-4 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                                        type="button"
                                        onClick={() => setOpenDropdown(openDropdown === 'sort' ? '' : 'sort')}
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                                            className="h-4 w-4 mr-2 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                            <path
                                                d="M3 9h4v2H3V9zm0-4h10v2H3V5zm0 8h7v2H3v-2zm10.59 4.59L15 17.59V4h2v13.59l1.41-1.41L20 18l-4 4-4-4 1.41-1.41z" />
                                        </svg>
                                        Sortează
                                    </motion.button>
                                </div>
                                <AnimatePresence>
                                    {openDropdown === 'actions' && (
                                        <motion.div
                                            id="actionsDropdown"
                                            className="z-10 w-44 right-0 relative bg-white rounded-lg divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600 justify-between items-center self-start"
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -10 }}
                                        >
                                            <ul className="py-1 text-sm text-gray-700 dark:text-gray-200"
                                                aria-labelledby="actionsDropdownButton">
                                                <li>
                                                    <button 
                                                        className="block py-2 w-full px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                        Editare în masă
                                                    </button>
                                                </li>
                                            </ul>
                                            <div className="py-1">
                                                <button 
                                                    className="block py-2 px-4 w-full text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">
                                                    Șterge tot
                                                </button>
                                            </div>
                                        </motion.div>
                                    )}
                                    {openDropdown === 'sort' && (
                                        <motion.div
                                            id="sortDropdown"
                                            className="z-10 w-44 right-0 relative bg-white rounded-lg divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600 justify-between items-center self-end"
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: -10 }}
                                        >
                                            <ul className="py-1 text-sm text-gray-700 dark:text-gray-200"
                                                aria-labelledby="actionsDropdownButton">
                                                <li>
                                                    <button 
                                                        className="block py-2 w-full px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                                                        Data
                                                    </button>
                                                </li>
                                            </ul>
                                            <div className="py-1">
                                                <button 
                                                    className="block py-2 px-4 w-full text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">
                                                    Nume
                                                </button>
                                            </div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                <thead
                                    className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" className="px-4 py-3 flex justify-center items-center ">TIP</th>
                                        <th scope="col" className="px-4 py-3">NUME</th>
                                        <th scope="col" className="px-4 py-3">DETALII</th>
                                        <th scope="col" className="px-4 py-3 md:hidden">DATA</th>
                                        <th scope="col" className="px-4 py-3 md:hidden">ORA</th>
                                        <th scope="col" className="px-4 py-3">
                                            <span className="sr-only">Actions</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <AnimatePresence>
                                        {filteredData.map((item, index) => (
                                            <motion.tr
                                                key={item.id}
                                                className="border-b dark:border-gray-700 items-center"
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                exit={{ opacity: 0, y: -20 }}
                                                transition={{ duration: 0.3, delay: index * 0.05 }}
                                            >
                                                <td className="px-4 py-3 flex justify-center items-center ">
                                                    {item.type === 'client' ? (
                                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M11.5002 11.5C13.6181 11.5 15.3335 9.78458 15.3335 7.66667C15.3335 5.54875 13.6181 3.83333 11.5002 3.83333C9.38225 3.83333 7.66683 5.54875 7.66683 7.66667C7.66683 9.78458 9.38225 11.5 11.5002 11.5Z M11.5002 13.4167C8.94141 13.4167 3.8335 14.7008 3.8335 17.25V19.1667H19.1668V17.25C19.1668 14.7008 14.0589 13.4167 11.5002 13.4167Z"
                                                                fill="#D9D9D9" />
                                                        </svg>
                                                    ) : (
                                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M21.5625 9.34375H20.5922L18.0963 3.72852C17.9834 3.47446 17.7992 3.25861 17.566 3.10712C17.3329 2.95563 17.0608 2.875 16.7828 2.875H6.21719C5.93916 2.875 5.66709 2.95563 5.43396 3.10712C5.20082 3.25861 5.01662 3.47446 4.90367 3.72852L2.40781 9.34375H1.4375C1.24688 9.34375 1.06406 9.41948 0.929267 9.55427C0.794475 9.68906 0.71875 9.87188 0.71875 10.0625C0.71875 10.2531 0.794475 10.4359 0.929267 10.5707C1.06406 10.7055 1.24688 10.7812 1.4375 10.7812H2.15625V17.9688C2.15625 18.35 2.3077 18.7156 2.57728 18.9852C2.84687 19.2548 3.2125 19.4062 3.59375 19.4062H5.75C6.13125 19.4062 6.49688 19.2548 6.76647 18.9852C7.03605 18.7156 7.1875 18.35 7.1875 17.9688V17.25H15.8125V17.9688C15.8125 18.35 15.964 18.7156 16.2335 18.9852C16.5031 19.2548 16.8688 19.4062 17.25 19.4062H19.4062C19.7875 19.4062 20.1531 19.2548 20.4227 18.9852C20.6923 18.7156 20.8438 18.35 20.8438 17.9688V10.7812H21.5625C21.7531 10.7812 21.9359 10.7055 22.0707 10.5707C22.2055 10.4359 22.2812 10.2531 22.2812 10.0625C22.2812 9.87188 22.2055 9.68906 22.0707 9.55427C21.9359 9.41948 21.7531 9.34375 21.5625 9.34375ZM7.1875 13.6562H5.03125C4.84063 13.6562 4.65781 13.5805 4.52302 13.4457C4.38823 13.3109 4.3125 13.1281 4.3125 12.9375C4.3125 12.7469 4.38823 12.5641 4.52302 12.4293C4.65781 12.2945 4.84063 12.2188 5.03125 12.2188H7.1875C7.37812 12.2188 7.56094 12.2945 7.69573 12.4293C7.83052 12.5641 7.90625 12.7469 7.90625 12.9375C7.90625 13.1281 7.83052 13.3109 7.69573 13.4457C7.56094 13.5805 7.37812 13.6562 7.1875 13.6562ZM17.9688 13.6562H15.8125C15.6219 13.6562 15.4391 13.5805 15.3043 13.4457C15.1695 13.3109 15.0938 13.1281 15.0938 12.9375C15.0938 12.7469 15.1695 12.5641 15.3043 12.4293C15.4391 12.2945 15.6219 12.2188 15.8125 12.2188H17.9688C18.1594 12.2188 18.3422 12.2945 18.477 12.4293C18.6118 12.5641 18.6875 12.7469 18.6875 12.9375C18.6875 13.1281 18.6118 13.3109 18.477 13.4457C18.3422 13.5805 18.1594 13.6562 17.9688 13.6562ZM3.98098 9.34375L6.21719 4.3125H16.7828L19.019 9.34375H3.98098Z"
                                                                fill="#D9D9D9" />
                                                        </svg>
                                                    )}
                                                </td>
                                                <th scope="row" className="px-4 py-3 font-medium text-gray-900 dark:text-white">
                                                    {item.type === 'client' ? item.name : item.description}
                                                </th>
                                                <td className="px-4 py-3">
                                                    {item.type === 'client' ? `Nr. mașini: ${item.nrMasini}` : `Nr. intervenții: ${item.interventionCount}`}
                                                </td>
                                                <td className="px-4 py-3 md:hidden">{item.date}</td>
                                                <td className="px-4 py-3 md:hidden">{item.time}</td>
                                                <td className="px-4 py-3 flex items-center justify-end">
                                                    <motion.button
                                                        className="inline-flex bg-red-500 items-center p-1 text-sm font-medium text-center text-white hover:text-gray-800 rounded-lg focus:outline-none dark:text-white dark:hover:text-gray-100"
                                                        type="button"
                                                        onClick={() => handleUndo(item.id, item)}
                                                        whileHover={{ scale: 1.05 }}
                                                        whileTap={{ scale: 0.95 }}
                                                    >
                                                        <svg className="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 9V3m6 6l-6-6-6 6m6 3v7a4 4 0 004 4h14" />
                                                        </svg>
                                                        Anulare
                                                    </motion.button>
                                                </td>
                                            </motion.tr>
                                        ))}
                                    </AnimatePresence>
                                </tbody>
                            </table>
                        </div>
                    </motion.div>
                </section>
            </main>
        </motion.div>
    );
};

export default DashboardHistory2;